import { render, staticRenderFns } from "./AddContacts.vue?vue&type=template&id=231eed2b&scoped=true"
import script from "./AddContacts.vue?vue&type=script&lang=js"
export * from "./AddContacts.vue?vue&type=script&lang=js"
import style0 from "./AddContacts.vue?vue&type=style&index=0&id=231eed2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231eed2b",
  null
  
)

export default component.exports